

















































































import Vue from 'vue'
import { getOrderContent } from '@/api/order'
import DescriptionElement from '@/components/DescriptionElement.vue'
import { IOrderPhoto } from '@/interfaces/order'
import { MetaInfo } from 'vue-meta/types/vue-meta'

export default Vue.extend({
  name: 'OrderDetails',
  components: { DescriptionElement },
  props: {
    // Photo Order ID
    orderId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      info: [] as string[],
      deleteMessage: '',
      downloadLink: '',
      images: [] as IOrderPhoto[]
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '查詢訂單',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    hasHistory (): boolean {
      return window.history.length > 2
    }
  },
  created () {
    window.navigateBack = this.onBackButtonClicked
    if (this.orderId.length !== 20) {
      this.$router.replace({ name: 'Order' })
      return
    }
    this.handleGetOrderContent()
  },
  methods: {
    async handleGetOrderContent () {
      this.$store.commit('SET_FOOTER', false)

      try {
        const token = this.$store.getters.isWebViewMode ? this.$route.query.token : this.$store.getters.token
        const requestBody = {
          token,
          order_id: this.orderId
        }
        const { data } = await getOrderContent(requestBody)
        if (data.flag === 0) {
          const payload = data.data
          this.info = payload.info
          this.deleteMessage = payload.delete_msg
          this.downloadLink = payload.download_link
          this.images = payload.images
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('SET_FOOTER', true)
      }
    },
    onBackButtonClicked () {
      if (this.hasHistory) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'Order' })
      }
    }
  }
})
